<template>
    <div class="footer flexBox justify-content-around">
        <div class="left flexBox justify-content-between">
            <div>
                <div class="fontBold">{{ $t('menu.cpzx') }}</div>
                <a :href="$i18n.locale == 'en' ? 'https://www.huayan-robotics.net/elfin-collaborative-robot':'https://www.huayan-robotics.com/elfin-pro'">{{ $t('footer.jqr') }}</a>
            </div>
            <div>
                <div class="fontBold">{{ $t('menu.hyyy') }}</div>
                <a :href="$i18n.locale == 'en' ? 'https://www.huayan-robotics.net/application/3c':'https://www.huayan-robotics.com/application?type-61=63'">{{ $t('footer.dz') }}</a>
            </div>
            <div>
                <div class="fontBold">{{ $t('footer.yyly') }}</div>
                <a :href="$i18n.locale == 'en' ? 'https://www.huayan-robotics.net/application/welding':'https://www.huayan-robotics.com/application?type-62=66'">{{ $t('footer.sxl') }}</a>
            </div>
            <div>
                <div class="fontBold">{{ $t('menu.fwzc') }}</div>
                <a :href="$i18n.locale == 'en' ? 'https://www.huayan-robotics.net/service/faq':'https://www.huayan-robotics.com/service/faq'" >{{ $t('footer.cjwt') }}</a>
            </div>
            <div>
                <div class="fontBold">{{ $t('menu.gywm') }}</div>
                <a :href="$i18n.locale == 'en' ? 'https://www.huayan-robotics.net/about-us/about':'https://www.huayan-robotics.com/about-us/about'">{{ $t('menu.gywm') }}</a>
            </div>
        </div>
        <div class="right">
            <div>{{ $t('footer.zxrx') }}:</div>
            <div class="number">400-852-9898</div>
            <div>{{ $t('dzyx') }}:</div>
            <div>marketing@huayan-robotics.com</div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
.footer {
    background: #F9FAFC;
    padding: 50px 0;
}

.left {
    min-width: 700px;
    color: rgba($color: #000000, $alpha: .5);

    >div {
        margin-right: 30px;
    }

    .fontBold {
        margin-bottom: 30px;
        color: rgba($color: #000000, $alpha: 1);

    }

    a {
        text-decoration: none;
        color: rgba($color: #000000, $alpha: .5);
    }
}

.right {
    font-size: 20px;
    font-weight: bold;

    .number {
        font-size: 30px;
    }
}

@media (max-width: 1024px) {
    .left {
        display: none;
    }

    .footer {
        justify-content: space-between;
        padding-left: 100px;
    }
}

@media (max-width: 900px) {
    .right {
        font-size: 18px;
        font-weight: bold;

        .number {
            font-size: 24px;
        }

        line-height: 150px;
    }
}
</style>